import { createEvent } from 'effector';

export const changeActiveProjectsEv = createEvent();

export const changeActiveRegionsEv = createEvent();

export const clearActiveProjectsEv = createEvent();

export const clearActiveRegionsEv = createEvent();

export const selectAllEv = createEvent();

export const setDefaultActiveProjectsEv = createEvent();

export const setDefaultRegionsValueEv = createEvent();
